// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Icon from 'vue-awesome/components/Icon'
import BootstrapVue from 'bootstrap-vue'
import VueResource from 'vue-resource'
import VueNotification from 'vue-notification'
import VueClip from 'vue-clip'

import App from './App'
import router from './router'
import apiProjects from './api/projects'
import apiLayers from './api/layers'

Vue.prototype.$apiProjects = apiProjects
Vue.prototype.$apiLayers = apiLayers

Vue.use(VueResource)
Vue.use(VueNotification)
Vue.use(VueClip)

import './scss/styles.scss'

Icon.register({
  redmine: {
    width: 128,
    height: 128,
    paths: [
      {
        d: 'M37.2 21.6l11.2 13c.5.6-.2 1.1-.2 1.1-4.5 2.4-7.7 6.1-10.5 10.3-.6.8-1.1.2-1.1.2L22.4 35.6s-.6-.4-.1-1.1c4.2-5.5 7.9-9.4 14-13.1 0 0 .4-.4.9.2'
      },
      {
        d: 'M17.3 42.8l16.8 8.1c.8.3.4 1 .4 1-2.3 5.5-3.7 10.2-4.8 15.8-.2.9-.8.6-.8.6L10 60.2s-.6-.2-.3-.9c.8-2.6 5.1-12.9 6.8-16.3 0 .1.3-.5.8-.2'
      },
      {
        d: 'M7.9 68.9c3.8 1.2 19.9 4.9 19.9 4.9 1 .3.7 1 .7 1-1.1 8.8-.9 15.4-.9 17.7 0 1-.7.9-.7.9H3.4c-1 0-.8-.9-.8-.9.2-2.9 1-11.2 4.3-23.1 0 0 .2-.8 1-.5'
      },
      {
        d: 'M84.8 21.6l-11.2 13c-.5.6.2 1.1.2 1.1 4.5 2.4 7.7 6.1 10.5 10.3.6.8 1.1.2 1.1.2l14.2-10.6s.6-.4.1-1.1c-4.2-5.5-7.9-9.4-14-13.1 0 0-.4-.4-.9.2'
      },
      {
        d: 'M61 32.7c1.9 0 5.4.2 7 .5.9.1 1.1-.4 1.1-.4L76.2 18s.5-.6-.5-.9c-5.3-1.9-8.1-2.8-14.6-2.8s-9.4.9-14.6 2.8c-1 .4-.5.9-.5.9l7.1 14.7s.2.6 1.1.4c1.4-.2 4.9-.4 6.8-.4'
      },
      {
        d: 'M104.7 42.8l-16.8 8.1c-.8.3-.4 1-.4 1 2.3 5.5 3.7 10.2 4.8 15.8.2.9.8.6.8.6l18.9-8.2s.6-.2.3-.9c-.8-2.6-5.1-12.9-6.8-16.3 0 .2-.3-.4-.8-.1'
      },
      {
        d: 'M114.1 68.9c-3.8 1.2-19.9 4.9-19.9 4.9-1 .3-.7 1-.7 1 1.1 8.8.9 15.4.9 17.7 0 1 .7.9.7.9h23.5c1 0 .8-.9.8-.9-.2-2.9-1-11.2-4.3-23.1 0 0-.2-.8-1-.5'
      }
    ]
  },
  "wall": {
    width: 24,
    height: 24,
    paths: [
      {
        d: 'M3,16H12V21H3V16M2,10H8V15H2V10M9,10H15V15H9V10M16,10H22V15H16V10M13,16H21V21H13V16M3,4H11V9H3V4M12,4H21V9H12V4Z'
      }
    ]
  }
})

Vue.config.productionTip = false
Vue.component('icon', Icon)
Vue.use(BootstrapVue)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js